/**
 * Given a name, extracts initials and generates a fallback avatar url.
 */
export function generateAvatarFallback (name) {
  if (!name) {
    return null
  }

  const initials = getInitials(name)
  return `https://dummyimage.com/128/2395F3/fff.png&text=+${initials}+`
}

function getInitials (str) {
  if (str.indexOf('@') > -1) {
    // It's an email, take the first and last part.
    const [, user, domain] = /(.*?)@(.*)/.exec(str)
    return `${user.charAt(0)}${domain.charAt(0)}`
  }

  const [first, last] = str.split(' ')
  return `${first.charAt(0)}${last.charAt(0)}`
}



// WEBPACK FOOTER //
// ./src/client/utils/dummyImageUtil.js